var _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgRatingSmallStar = function SvgRatingSmallStar(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    stroke: "#FFC401",
    strokeWidth: 0.4,
    d: "M13.18 15.55h-.01a.552.552 0 0 1-.253-.06v-.001l-3.824-2.002L9 13.438l-.093.049-3.825 2.002a.55.55 0 0 1-.797-.582l-.197-.035.197.035.75-4.223.018-.104-.076-.074-3.089-3a.55.55 0 0 1-.137-.547.55.55 0 0 1 .445-.372l4.275-.622.105-.016.046-.094 1.883-3.848a.55.55 0 0 1 .99 0v.001l1.906 3.84.046.094.104.015 4.275.623a.55.55 0 0 1 .446.372.55.55 0 0 1-.137.547l-3.09 3-.075.073.018.105.75 4.222v.003a.55.55 0 0 1-.218.549.55.55 0 0 1-.34.098Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 9.011,
    x2: 9.011,
    y1: 1.496,
    y2: 15.753,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFF00"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
};
export default SvgRatingSmallStar;